import apiFetch from '../apiFetch'

export default function (idAnalisisExtraccion, token) {
  return apiFetch({endPoint: `Analisis/eliminarAnalisis?idAnalisis=` + idAnalisisExtraccion, method: 'GET', body: null, token: token})
}
